/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { Button } from 'reactstrap';
import { GroupQuestionListProps } from './types';
import { Column, Divider } from '@g17eco/molecules/tracking-list';

interface GroupCheckboxProps extends GroupQuestionListProps {
  toggleClickQuestions: (utrIds: string[]) => void;
  selectedQuestionIds: string[];
  className?: string;
}

export const GroupCheckbox = (props: GroupCheckboxProps) => {
  const { questionGroup, questionList, toggleClickQuestions, selectedQuestionIds, className } = props;

  if (questionGroup?.list?.length === 0) {
    return null;
  }

  let isSelected = selectedQuestionIds.length > 0;
  let isPartial = false;

  const handleToggleGroup = (e?: React.MouseEvent) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    toggleClickQuestions(questionList.map((q) => q.universalTracker.getId()).filter((u) => u !== undefined));
  };

  questionList.every((q) => {
    const found = selectedQuestionIds.includes(q.universalTracker.getId());
    if (found) {
      isPartial = true;
    } else {
      isSelected = false;
      if (isPartial) {
        // Early exit as we already know it has to be a partial
        return false;
      }
    }
    return true;
  });

  const getIcon = () => {
    if (isSelected) {
      return 'fa-solid fa-square-check text-ThemeAccentMedium';
    }
    if (isPartial) {
      return 'fa-solid fa-square-minus text-ThemeAccentMedium';
    }
    return 'far fa-square text-ThemeNeutralsDark';
  };

  return (
    <div className='d-flex'>
      <Divider />
      <Column className={`combined-utrs-list__select-box ${className ?? ''}`}>
        <Button color='link' onClick={handleToggleGroup} className='p-0'>
          <i className={getIcon()} />
        </Button>
      </Column>
    </div>
  );
};
